<div class="image-gallery-wrapper" id="gallery">
  <div class="large-image-wrapper" [class.hide-thumbnails]="!showThumbnails">
    <div *ngIf="!showThumbnails" class="page-number-top">
      {{ (selectedIndex$ | async) + 1 }}/{{ images.length }}
    </div>
    <span
      *ngIf="selectedIndex$ | async as selectedIndex"
      class="arrow left-arrow"
      (click)="onPrevious()"
    >
      <i2g-icon [name]="arrowBackIcon" size="small"></i2g-icon>
    </span>
    <button class="full-screen-icon" (click)="onFullScreen()">
      <i2g-icon [name]="zoomEnlargeIcon" size="medium"></i2g-icon>
    </button>
    <img
      class="large-image"
      [src]="this.images[selectedIndex$ | async].url"
      alt="image"
    />
    <span
      class="arrow right-arrow"
      (click)="onNext()"
      [class.hide]="(selectedIndex$ | async) === images.length - 1"
    >
      <i2g-icon [name]="arrowForwardIcon" size="small"></i2g-icon>
    </span>
    <span *ngIf="showThumbnails" class="page-number"
      >{{ (selectedIndex$ | async) + 1 }}/{{ images.length }}</span
    >
  </div>
  <div *ngIf="thumbnails" class="image-row-wrapper">
    <div *ngFor="let img of thumbnails; let index = index" class="small-images">
      <img
        class="small-image"
        [src]="img.url"
        alt="image"
        (click)="onSelectImage(index)"
      />
    </div>
  </div>
</div>

<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  style="position: fixed; width: 0; height: 0"
>
  <symbol
    id="zoom-enlarge-icon"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icons-/-24-/-Zoom-Enlarge"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <polygon
        id="Rectangle"
        fill="#fff"
        points="3 3 8.00415039 3 8 5 5 5.0065918 5 8 3 8"
      ></polygon>
      <polygon
        id="Rectangle-Copy-3"
        fill="#fff"
        transform="translate(5.502075, 18.500000) scale(1, -1) translate(-5.502075, -18.500000) "
        points="3 16 8.00415039 16 8 18 5 18.0065918 5 21 3 21"
      ></polygon>
      <polygon
        id="Rectangle-Copy-2"
        fill="#fff"
        transform="translate(18.502075, 5.500000) scale(-1, 1) translate(-18.502075, -5.500000) "
        points="16 3 21.0041504 3 21 5 18 5.0065918 18 8 16 8"
      ></polygon>
      <polygon
        id="Rectangle-Copy-4"
        fill="#fff"
        transform="translate(18.502075, 18.500000) scale(-1, -1) translate(-18.502075, -18.500000) "
        points="16 16 21.0041504 16 21 18 18 18.0065918 18 21 16 21"
      ></polygon>
    </g>
  </symbol>

  <symbol
    id="arrow-forward-icon"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icons-/-24-/-Arrow-Forward"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Arrow"
        transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
      >
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
      </g>
      <mask id="mask-2" fill="white">
        <path
          d="M9.63368752,11.9317949 L18.3352074,20.112711 C18.7612339,20.5132487 18.7612339,21.1626487 18.3352074,21.5631864 C17.9091809,21.9637242 17.2184555,21.9637242 16.792429,21.5631864 L7.31951988,12.6570326 C6.89349337,12.2564949 6.89349337,11.6070949 7.31951988,11.2065571 L16.792429,2.3004033 C17.2184555,1.89986557 17.9091809,1.89986557 18.3352074,2.3004033 C18.7612339,2.70094104 18.7612339,3.35034101 18.3352074,3.75087875 L9.63368752,11.9317949 Z"
        ></path>
      </mask>
      <path
        d="M9.63368752,11.9317949 L18.3352074,20.112711 C18.7612339,20.5132487 18.7612339,21.1626487 18.3352074,21.5631864 C17.9091809,21.9637242 17.2184555,21.9637242 16.792429,21.5631864 L7.31951988,12.6570326 C6.89349337,12.2564949 6.89349337,11.6070949 7.31951988,11.2065571 L16.792429,2.3004033 C17.2184555,1.89986557 17.9091809,1.89986557 18.3352074,2.3004033 C18.7612339,2.70094104 18.7612339,3.35034101 18.3352074,3.75087875 L9.63368752,11.9317949 Z"
        fill="#162D3D"
        transform="translate(12.827364, 11.931795) scale(-1, 1) translate(-12.827364, -11.931795) "
      ></path>
    </g>
  </symbol>

  <symbol
    id="arrow-back-icon"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icons-/-24-/-Arrow-Back"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <path
          d="M7.63368752,11.9317949 L16.3352074,20.112711 C16.7612339,20.5132487 16.7612339,21.1626487 16.3352074,21.5631864 C15.9091809,21.9637242 15.2184555,21.9637242 14.792429,21.5631864 L5.31951988,12.6570326 C4.89349337,12.2564949 4.89349337,11.6070949 5.31951988,11.2065571 L14.792429,2.3004033 C15.2184555,1.89986557 15.9091809,1.89986557 16.3352074,2.3004033 C16.7612339,2.70094104 16.7612339,3.35034101 16.3352074,3.75087875 L7.63368752,11.9317949 Z"
        ></path>
      </mask>
      <path
        d="M7.63368752,11.9317949 L16.3352074,20.112711 C16.7612339,20.5132487 16.7612339,21.1626487 16.3352074,21.5631864 C15.9091809,21.9637242 15.2184555,21.9637242 14.792429,21.5631864 L5.31951988,12.6570326 C4.89349337,12.2564949 4.89349337,11.6070949 5.31951988,11.2065571 L14.792429,2.3004033 C15.2184555,1.89986557 15.9091809,1.89986557 16.3352074,2.3004033 C16.7612339,2.70094104 16.7612339,3.35034101 16.3352074,3.75087875 L7.63368752,11.9317949 Z"
        fill="#162D3D"
      ></path>
    </g>
  </symbol>
</svg>
